export default "__VITE_ASSET__Dm6ES3Rs__"